import moment from 'moment';
import { checkUndefined, formatDateTimeHours } from './globalFunction'

export default function LeaveRecordCollection(getLeaveRecord, page, intl) {
    const myLeaves = [];
    const guidelineIntl = 'guideline.';
    const newApplicationIntl = 'new_application.';
    const statusIntl = 'status.';

    for (let i = 0; i < getLeaveRecord.length; i++) {
        switch (page) {
            case 'LeaveApproval':
                const typeName = getLeaveRecord[i].application.type.name;
                let getAnnualTotal = 'NA'

                if (typeName === 'Annual Leave') {
                    getAnnualTotal = (Number(getLeaveRecord[i].application.employee.annual_total)).toFixed(1);
                }

                myLeaves.push({
                    id: `${getLeaveRecord[i].id}`,
                    employeeName: `${getLeaveRecord[i].application.employee.employee_name}`,
                    staffNo: `${getLeaveRecord[i].application.employee.staff_no}`,
                    position: `${getLeaveRecord[i].application.employee.position}`,
                    location: `${getLeaveRecord[i].application.employee.location.name}`,
                    department: `${getLeaveRecord[i].application.employee.department.name}`,
                    type: `${intl.formatMessage({ id: guidelineIntl + getLeaveRecord[i].application.type.name })}`,
                    dateSubmitted: `${moment(getLeaveRecord[i].application.created_at).format(window.global.displayDateTimeFormat)}`,
                    dateApproved: `${moment(getLeaveRecord[i].updated_at).format(window.global.displayDateTimeFormat)}`,
                    startDate: formatDateTimeHours(getLeaveRecord[i].application, 'startDate', intl),
                    untilDate: formatDateTimeHours(getLeaveRecord[i].application, 'untilDate', intl),
                    period: formatDateTimeHours(getLeaveRecord[i].application, 'period', intl),
                    status: `${intl.formatMessage({ id: statusIntl + getLeaveRecord[i].application.status })}`,
                    approveStatus: `${intl.formatMessage({ id: statusIntl + getLeaveRecord[i].status })}`,
                    reason: `${getLeaveRecord[i].application.reason}`,
                    annualTotal: `${getAnnualTotal}`,
                    approvalComment: getLeaveRecord[i].comment? getLeaveRecord[i].comment:'N/A',
                });
                break;
            case 'ExportLeaveDetail':
                myLeaves.push({
                    id: `${getLeaveRecord[i].id}`,
                    employeeName: `${getLeaveRecord[i].employee.employee_name}`,
                    staffNo: `${getLeaveRecord[i].employee.staff_no}`,
                    position: `${getLeaveRecord[i].employee.position}`,
                    location: `${getLeaveRecord[i].employee.location.name}`,
                    department: `${getLeaveRecord[i].employee.department.name}`,
                    type: `${intl.formatMessage({ id: guidelineIntl + getLeaveRecord[i].type.name })}`,
                    dateSubmitted: `${moment(getLeaveRecord[i].created_at).format(window.global.displayDateTimeFormat)}`,
                    startDate: formatDateTimeHours(getLeaveRecord[i], 'startDate', intl),
                    untilDate: formatDateTimeHours(getLeaveRecord[i], 'untilDate', intl),
                    period: formatDateTimeHours(getLeaveRecord[i], 'period', intl),
                    status: `${intl.formatMessage({ id: statusIntl + getLeaveRecord[i].status })}`,
                    reason: `${checkUndefined(getLeaveRecord[i].reason)}`,
                    attachment: `${getLeaveRecord[i].has_attachment ? intl.formatMessage({ id: 'new_application.provided' }) : ''}`,
                    rejectReason: handleRejectReason(getLeaveRecord[i]),
                });
                break;
            default:
                myLeaves.push({
                    id: `${getLeaveRecord[i].id}`,
                    type: `${intl.formatMessage({ id: guidelineIntl + getLeaveRecord[i].type.name })}`,
                    dateSubmitted: `${moment(getLeaveRecord[i].created_at).format(window.global.displayDateTimeFormat)}`,
                    startDate: formatDateTimeHours(getLeaveRecord[i], 'startDate', intl),
                    untilDate: formatDateTimeHours(getLeaveRecord[i], 'untilDate', intl),
                    period: formatDateTimeHours(getLeaveRecord[i], 'period', intl),
                    status: `${intl.formatMessage({ id: statusIntl + getLeaveRecord[i].status })}`,
                    reason: `${getLeaveRecord[i].reason}`,
                });
                break;
        }
    }
    return myLeaves;
}

export function handleRejectReason(leaveRecord) {
    const { start_time, processing_application, process_comp_leave_application } = leaveRecord;
    const patterns = window.global.patterns;
    const isContainsPatterns = patterns.some(term => start_time.includes(term));

    const getComment = (applicationArray) => {
        return applicationArray.length === 0 ? '' : checkUndefined(applicationArray[0].comment);
    }

    if (isContainsPatterns) {
        return getComment(processing_application);
    } else {
        return getComment(process_comp_leave_application);
    }
}